import React from "react";
import PropTypes from "prop-types";
import createFieldClasses from "../../../services/contact-form-services";
import fieldTypes from "../../../services/field-prop-types";

const Company = ({ dataQa, error, data, handleInputChange, label }) => (
    <div className={createFieldClasses(error, data)}>
        <input
            data-qa={dataQa}
            id="company"
            onChange={handleInputChange}
            value={data}
            autoComplete="organization"
            type="text"
            name="company"
            required
            maxLength="255"
        />
        <label data-qa={`${dataQa}-label`} htmlFor="company">
            {label}
        </label>
    </div>
);

Company.propTypes = {
    ...fieldTypes,
    label: PropTypes.string.isRequired
};

export default Company;
